import React from "react";
import { FaFacebook, FaInstagram, FaWhatsapp, FaYoutube } from "react-icons/fa";
import { Link } from 'gatsby';
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>CV Bunga Toba</h3>
          <ul>
          <li> 
              <Link to="/">Home</Link>
          </li>
          <li>
              <Link to="/about">About</Link>
          </li>
          <li>
              <Link to="/blog">Product</Link>
          </li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Produk</h4>
          <ul>
            <li>
              <Link to="/flow-meter-nitto-seiko-br13-3">Flow Meter Nitto Seiko</Link>
            </li>
            <li>
              <Link to="/flow-meter-liquidcontrol-m5">Flow Meter Liquid Control</Link>
            </li>
            <li>
              <Link to="/flow-meter-tokico-4inch">Flow Meter Tokico </Link>
            </li>
            <li>
              <Link to="/flow-meter-air-dki-3inch">Flow Meter Air</Link>
            </li>
           </ul>
           
        </div>

        <div className="footer-section">
          <h4>Contact Details</h4>
            <p>Alamat: Harco Glodok Lt. 5 Blok C No. 23</p>
            <p>Wa: 0813 1151 8884</p>
            <p>Telp: 021 2268 0742</p>
            <p>Email: salesbtmeter@gmail.com</p>
          
        </div>

        <div className="footer-social">
          <h4>Follow us</h4>
          <div className="social-icons">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FaFacebook size={24} />
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram size={24} />
            </a>
            <a
              href="https://wa.me/6281311518884"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
            >
              <FaWhatsapp size={24} />
            </a>
            <a
              href="https://youtube.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <FaYoutube size={24} />
            </a>
          </div>
        </div>
      </div>

     
      <div class="footer-bottom">
    © 2025 CV Bunga Toba | Designed by Simon Kasih H
  </div>
  
         
       
    
    </footer>
  );
};

export default Footer;
